/**
 * Actualiza el bloque de precios cuando cambia la variante.
 * Compatible con eventos de tema y con selects/inputs name="id" de Shopify.
 */
(function () {
  const BLOCK_SELECTOR = '.benard-price-block';
  const VARIANT_INPUT_SELECTOR = 'select[name="id"], input[name="id"]';

  function formatUsd(amount) {
    if (amount === '' || amount === undefined || amount === null) {
      return '';
    }

    const value = Number(amount);
    if (Number.isNaN(value)) {
      return '';
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  }

  function parseVariantMap(block) {
    const mapNode = block.querySelector('[data-role="variant-pricing-map"]');
    if (!mapNode) {
      return {};
    }

    try {
      return JSON.parse(mapNode.textContent || '{}');
    } catch (error) {
      console.warn('Benard pricing: invalid variant pricing map', error);
      return {};
    }
  }

  function getVariantId(variant) {
    if (!variant) {
      return '';
    }

    return String(variant.id || variant.variant_id || variant);
  }

  function escapeCss(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return value.replace(/["\\]/g, '\\$&');
  }

  function findBlockBySection(sectionId) {
    if (!sectionId) {
      return document.querySelector(BLOCK_SELECTOR);
    }

    return (
      document.querySelector(`${BLOCK_SELECTOR}[data-section-id="${escapeCss(String(sectionId))}"]`) ||
      document.querySelector(`#shopify-section-${escapeCss(String(sectionId))} ${BLOCK_SELECTOR}`) ||
      document.querySelector(BLOCK_SELECTOR)
    );
  }

  function findNearestBlock(element) {
    if (!element) {
      return document.querySelector(BLOCK_SELECTOR);
    }

    const section = element.closest('[id^="shopify-section-"], section, product-info, product-form, form');
    return section?.querySelector(BLOCK_SELECTOR) || document.querySelector(BLOCK_SELECTOR);
  }

  function updateBlock(block, variantId, fallbackUsdPrice) {
    if (!block) return;

    const normalizedVariantId = String(variantId || block.dataset.variantId || '');
    const variantMap = parseVariantMap(block);
    const variantData = variantMap[normalizedVariantId] || {};
    const usdPrice = variantData.usdPrice ?? fallbackUsdPrice ?? block.dataset.usdPrice;
    const isForeign = block.dataset.isForeign === 'true';

    block.dataset.variantId = normalizedVariantId;
    block.dataset.usdPrice = usdPrice || '';
    if (variantData.available !== undefined) {
      block.dataset.available = String(Boolean(variantData.available));
    }

    const clpAmount = block.querySelector('[data-role="clp-amount"]');
    if (clpAmount && variantData.clpPrice) {
      clpAmount.textContent = variantData.clpPrice;
    }

    const usdBlock = block.querySelector('[data-role="usd-block"]');
    const usdAmount = usdBlock ? usdBlock.querySelector('[data-role="usd-amount"]') : null;
    const usdLabel = usdBlock ? usdBlock.querySelector('.benard-price-block__usd-label') : null;

    if (usdBlock && usdAmount && usdLabel) {
      if (usdPrice) {
        usdAmount.textContent = formatUsd(usdPrice);
        usdAmount.dataset.rawValue = String(usdPrice);
        usdLabel.textContent = isForeign ? 'Precio estimado en USD:' : 'Referencia USD:';
        usdBlock.hidden = false;
      } else {
        usdBlock.hidden = true;
      }
    }
  }

  function handleVariantEvent(event) {
    const detail = event.detail || {};
    const variant = detail.variant || detail.selectedVariant || detail;
    if (!variant) return;
    const block = findBlockBySection(detail.sectionId || detail.section?.id);
    if (!block) return;

    const usdMetafields = variant.metafields?.international?.usd_price;
    const usdPrice = usdMetafields?.value || usdMetafields;
    updateBlock(block, getVariantId(variant), usdPrice);
  }

  function handleVariantInputChange(event) {
    const target = event.target;
    if (!(target instanceof Element) || !target.matches(VARIANT_INPUT_SELECTOR)) {
      return;
    }

    updateBlock(findNearestBlock(target), target.value);
  }

  function refreshAllBlocks() {
    document.querySelectorAll(BLOCK_SELECTOR).forEach((block) => {
      updateBlock(block, block.dataset.variantId, block.dataset.usdPrice);
    });
  }

  document.addEventListener('variant:change', handleVariantEvent);
  document.addEventListener('product:variant-change', handleVariantEvent);
  document.addEventListener('variantChange', handleVariantEvent);
  document.addEventListener('change', handleVariantInputChange);
  document.addEventListener('shopify:section:load', refreshAllBlocks);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllBlocks);
  } else {
    refreshAllBlocks();
  }
})();

